import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

// import {
//   auth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   createUserWithEmailAndPassword,
//   setDoc,
//   doc,
//   db,
//   addDoc,
//   collection,
//   signOut,
//   onAuthStateChanged,
//   query,
//   where,
//   onSnapshot,
// } from '/Users/adityarouniyar/Desktop/convoai/src/firebase/config.js';

const AgentBuilder = ({ setActiveTab }) => {
    const { user } = useAuth();
    const [agentData, setAgentData] = useState({
        name: '',
        description: '',
        voice: 'alloy',
        language: 'English',
        personality: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAgentData(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!user) {
            alert("You must be logged in to create an agent.");
            return;
        }
        try {
            await addDoc(collection(db, "agents"), {
                ...agentData,
                userId: user.uid,
                createdAt: new Date().toISOString()
            });
            alert("Agent created successfully!");
            setActiveTab('dashboard');
        } catch (error) {
            console.error("Error creating agent:", error);
            alert("Failed to create agent. Please try again.");
        }
    };

    const voices = ['alloy', 'echo', 'fable', 'onyx', 'nova', 'shimmer'];
    const languages = ['English', 'Spanish', 'French', 'German', 'Hindi', 'Italian', 'Japanese', 'Portuguese', 'Korean'];

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Create New Agent</h1>
            <div className="bg-white p-8 rounded-lg shadow-lg">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Agent Name</label>
                        <input type="text" name="name" id="name" value={agentData.name} onChange={handleChange} required className="mt-1 block w-full input-style" placeholder="e.g., Customer Support Bot" />
                    </div>
                    <div>
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea name="description" id="description" rows="3" value={agentData.description} onChange={handleChange} className="mt-1 block w-full input-style" placeholder="Briefly describe what this agent does."></textarea>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="voice" className="block text-sm font-medium text-gray-700">Voice</label>
                            <select name="voice" id="voice" value={agentData.voice} onChange={handleChange} className="mt-1 block w-full input-style">
                                {voices.map(v => <option key={v} value={v} className="capitalize">{v}</option>)}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="language" className="block text-sm font-medium text-gray-700">Language</label>
                            <select name="language" id="language" value={agentData.language} onChange={handleChange} className="mt-1 block w-full input-style">
                                {languages.map(l => <option key={l} value={l}>{l}</option>)}
                            </select>
                        </div>
                    </div>
                    <div>
                        <label htmlFor="personality" className="block text-sm font-medium text-gray-700">Personality & Behavior</label>
                        <textarea name="personality" id="personality" rows="5" value={agentData.personality} onChange={handleChange} className="mt-1 block w-full input-style" placeholder="Describe the agent's personality. e.g., 'You are a friendly and helpful assistant. Keep your answers concise.'"></textarea>
                    </div>
                    <div className="flex justify-end space-x-4">
                        <button type="button" onClick={() => setActiveTab('dashboard')} className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg hover:bg-[#7B34BB]/20">Cancel</button>
                        <button type="submit" className="bg-[#B67BF4] text-white px-6 py-2 rounded-lg hover:bg-[#7B34BB]">Create Agent</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AgentBuilder;

